import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AnalyticsQueryTemplate } from 'dashboard/models/analytics-query-template';

export interface AnalyticsQueryTemplatesState {
  templates: AnalyticsQueryTemplate[];
}

const initialState: AnalyticsQueryTemplatesState = {
  templates: [],
};

interface SetAnalyticsQueryTemplatesAction {
  templates: AnalyticsQueryTemplate[];
}

const { reducer, actions } = createSlice({
  name: 'analyticsQueryTemplates',
  initialState,
  reducers: {
    setAnalyticsQueryTemplates: (
      state,
      action: PayloadAction<SetAnalyticsQueryTemplatesAction>,
    ) => {
      state.templates = action.payload.templates;
      return state;
    },
    setNewAnalyticsQueryTemplate: (state, action: PayloadAction<AnalyticsQueryTemplate>) => {
      state.templates = [...state.templates, action.payload];
    },
    archiveAnalyticsQueryTemplate: (state, action: PayloadAction<AnalyticsQueryTemplate>) => {
      const { payload } = action;
      state.templates = state.templates.filter(({ id }) => id !== payload.id);
    },
  },
});

export const {
  setAnalyticsQueryTemplates,
  setNewAnalyticsQueryTemplate,
  archiveAnalyticsQueryTemplate,
} = actions;

export const analyticsQueryTemplatesReducer = reducer;
